
export const validateStreetAddressErrors = (name) => {
    // try {
    const regex = RegExp(/^.*$/);
    if (name.length > 0) {
        if (regex.test(name)) {
            return false;
        } else {
            return 'current_address.street_address_error';
        }
    } else {
        // setStreetAddressValid(false)
        // setStreetAddressError('current_address.street_address_error')
        return 'current_address.street_address_error';
    }
    // } catch (e) {
    //     console.log(e)
    //     setIsError(true)
    // }
}

export const validateApartmentErrors = (name, required = false) => {
    return false;
    // const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    // if (name.length > 0) {
    //     if (regex.test(name)) {
    //         return false;

    //     } else {
    //         return 'current_address.apartment_error_invalid'
    //     }
    // } else {
    //     return required ? 'errors.apartment_required' : false;
    // }
}


export const validateCityErrors = (cityName, required = true) => {
    // try {
    const regex = RegExp(/^[a-zA-Z-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
    if (cityName.length > 0) {
        if (regex.test(cityName)) {
            return false
        } else {
            return 'current_address.city_error';
            // setCityValid(false)
            // setCityError('current_address.city_error_invalid')
        }
    } else {
        return 'current_address.city_error';
        // setCityValid(false)
        // setCityError('current_address.city_error')
    }
    // } catch (e) {
    //     console.log(e)
    //     setIsError(true)
    // }
}


export const validatePostalCodeErrors = (number, required = true) => {
    const regex = RegExp(/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/i)
    if (regex.test(number)) {
        return false;
        // setPostalCodeValid(true);
    } else {
        return 'current_address.ns_postal_code_error';
        // setPostalCodeValid(false)
        // setPostalCodeError('current_address.ns_postal_code_error')
    }
}